import { PlanTemplate } from '../../entities/applicant_tracking/PlanTemplate';
import { StagePlanTemplate } from '../../entities/applicant_tracking/StagePlanTemplate';
import { UpsertPlanTemplateDto } from '../../containers/PlanTemplates/SetupPlanTemplatePage/DTOs/UpsertPlanTemplateDto';
import { JobStageTemplate } from '../../entities/applicant_tracking/JobStageTemplate';
import { JobStageTemplateInput } from '../../containers/PlanTemplates/SetupPlanTemplatePage';
import { Control, useWatch } from 'react-hook-form';

export function mapJobStagesToStagePlanTemplates(
  jobStages: JobStageTemplateInput[],
): StagePlanTemplate[] {
  return jobStages?.map((stage) => ({
    id: stage.id,
    name: stage.name,
    order: stage.index,
    interviewsCount: stage.interviewsCount,
    interviewKitTemplateId: stage.interviewKitTemplate?.id,
    scorecardTemplateId: stage.scorecardTemplate?.id,
    uniqueKey: stage.uniqueKey,
  }));
}

export function mapJobStageToJobStageInput(
  jobStages: JobStageTemplate[],
): JobStageTemplateInput[] {
  return jobStages
    ?.sort((a, b) => a.order - b.order)
    .map((stage, index) => ({
      index,
      uniqueKey: window.crypto.randomUUID(),
      ...stage,
    }));
}

export function buildUpsertPlanTemplateDto(
  planTemplate?: PlanTemplate,
  jobStages?: JobStageTemplateInput[],
): UpsertPlanTemplateDto {
  return {
    id: planTemplate?.id,
    name: planTemplate?.name,
    stagePlanTemplates: mapJobStagesToStagePlanTemplates(jobStages),
  };
}

export function processJobStageIndexes(jobStages: StagePlanTemplate[]) {
  let interviewStagesCount = 0;

  return jobStages.map((stage, index) => {
    if (stage.interviewKitTemplateId) {
      interviewStagesCount++;
    }

    return {
      ...stage,
      order: index + interviewStagesCount,
    };
  });
}

export function getReferenceTemplate(
  planTemplates: PlanTemplate[],
  control: Control<UpsertPlanTemplateDto, any>,
): PlanTemplate {
  const referenceTemplateId = useWatch({
    control: control,
    name: 'planTemplateReferenceId',
  });

  if (referenceTemplateId == null) {
    return null;
  }

  return planTemplates.find(
    (planTemplate) =>
      planTemplate.id.toString() === referenceTemplateId.toString(),
  );
}
